import {
  DateTime,
} from 'luxon';

// Define a generic type that extends an object with a string property
type ObjectWithStringKey<T extends string> = {
  [key in T]: string;
};

export const alphSortByKey = <T extends string>(key: T) => {
  <U extends ObjectWithStringKey<T>>(a: U, b: U) => {
    a[key].localeCompare(b[key]);
  };
};

export const alphSortSearchOptions = (a, b) => (
  a.label?.toLowerCase() > b.label?.toLowerCase() ? 1 : -1
);

export const alphSortByUserName = (a, b) => (
  `${a.user_profile.first_name} ${a.user_profile.last_name}`.toLowerCase()
    > `${b.user_profile.first_name} ${b.user_profile.last_name}`.toLowerCase() ? 1 : -1
);

export const sortByPosition = (a, b) => (
  a.position > b.position ? 1 : -1
);

export const sortByLetter = (a, b) => (
  a.letter > b.letter ? 1 : -1
);

export const sortByDate = (name, reverse = false) => (a, b) => {
  const l = reverse ? 1 : -1;
  const r = reverse ? -1 : 1;
  return DateTime.fromISO(a[name]) > DateTime.fromISO(b[name]) ? l : r;
};

export const sortByOrderName = (
  a: any,
  b: any,
) => a.order_name.toLowerCase().localeCompare(b.order_name.toLowerCase(), undefined, {
  numeric: true,
  sensitivity: 'base',
})

export const onlyUniqueId = (value: any, index: any, self: any[]) => (
  self.findIndex(item => item.id === value.id) === index
)

export const stripLeadingSymbols = (str: string): string => {
  return str?.replace(/^[^a-zA-Z0-9]+/, '');
};

export const alphSortByName = (a: any, b: any) => {
  const nameA = stripLeadingSymbols(a.name?.toLowerCase());
  const nameB = stripLeadingSymbols(b.name?.toLowerCase());
  return nameA?.localeCompare(nameB, undefined, {
    numeric: true,
    sensitivity: 'base',
  });
}
